<template>
  <div>
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
      <div role="tabpanel">
        <ul id="fileserviceTabs" class="nav nav-tabs bar_tabs pull-right" role="tablist">
          <li role="presentation" :class="{'animated bounce infinite bold loadedFileActive': loadedFileStatus }">
            <a href="#detailTab" data-toggle="tab" @click="loadedFileStatus = false" ><i class="fas fa-info-circle"></i> File details {{ loadFileId }}</a>
          </li>
          <li role="presentation">
            <a href="#uploadTab" data-toggle="tab"><i class="fas fa-file-upload"></i> Upload new</a>
          </li>
          <li role="presentation">
            <a href="#overviewTab" data-toggle="tab" class="active"><i class="fas fa-table"></i> Overview</a>
          </li>
        </ul>
        <div id="fileserviceTabContent" class="tab-content">
          <div class="tab-pane" id="uploadTab">
            <fileupload ref="fileUploader" v-on:fileUploaded="reloadTable()"></fileupload>
          </div>
          <div class="tab-pane" id="detailTab">
            <filedetails :fileId="loadFileId" ref="fileEditor" :loadedFileId.sync="loadFileId" :loadedFileStatus.sync="loadedFileStatus" v-on:fileSaved="reloadTable()"></filedetails>
          </div>
          <div class="tab-pane active" role="tabpanel" id="overviewTab">
            <!--- Left panel with open files -->
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="card">           
                <div class="card-content">
                  <v-server-table :url="tableDataUrl" :columns="columns" ref="fileserviceTable" :options="options">
                    <template slot="status" slot-scope="props">
                      <span class="text-center blockdisplay statusIcon">
                        <span v-if="props.row.status == 'completed'" class="text-success"><i class="fas fa-check-circle"></i></span> 
                        <span v-if="props.row.status == 'pending'" class="text-pending"><i class="fas fa-clock"></i></span> 
                        <span v-if="props.row.status == 'canceled'" class="text-error"><i class="fas fa-times"></i></span>
                      </span>
                    </template>
                    <template slot="child_row" slot-scope="props" class="fileservice-child-row" v-if="props.row.status == 'completed'">
                      <table width="100%" class="table table-hover fsTableFileList">
                        <tr v-for="(file, key) in props.row.files">
                          <th scope="row">File {{ parseInt(key + 1) }}</th>
                          <td>{{ file.name }}</td>
                          <td><a @click="downloadFiles(props.row.id, file.name)" href="#" class="btn btn-primary"><i class="fas fa-download fa-lg"></i></a></td>
                        </tr>
                        </table>
                        <em v-if="props.row.admin_notes"><strong>Special instructions:</strong> {{ props.row.admin_notes }}</em>
                    </template>
                    <template slot="serieName" slot-scope="props">
                      {{ props.row.brandName }} {{ props.row.serieName }} {{ props.row.engineName}}
                    </template>
                    <template slot="actions" slot-scope="props"  v-if="props.row.status == 'completed'">
                      <a @click="downloadFiles(props.row.id)" class="btn btn-primary"><i class="fas fa-file-archive"></i> download all as zip</a>
                    </template>
                  </v-server-table>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import Filedetails from '../../components/file'
import Fileupload from '../../components/automaticUpload'
export default {
  components: {
    Filedetails,
    Fileupload
  },
  data: function () {
    return {
    openFileOnLoadId: this.$route.params.fileId,
    loadedFileStatus: false,
    loadFileId: '',
    tableDataUrl: APIURL + '/files',
    columns: ['status', 'credits', 'serieName', 'product', 'actions'],
    options: {
        childRow: function(h, row) {
            return row;
        },
        headings: {
          'email' : 'Customer',
          'serieName' : 'Vehicle'
        },
        perPage: 10,
        rowClassCallback: function(row) {
            if(row.status == 'pending') {
            return 'fileOverviewRowPending';
            }
            if(row.status == 'completed') {
            return 'fileOverviewRowFinished';
            }
            if(row.status == 'canceled') {
            return 'fileOverviewRowCanceled';
            }
        }
    },
    }
  },
  mounted: function () {
    if(this.openFileOnLoadId) {
      this.editRow(this.openFileOnLoadId);
      $('.nav-tabs a[href="#detailTab"]').tab('show');
    }
  },
  methods: {
    reloadTable() {
      this.$refs.fileserviceTable.getData();
      $("html, body").animate({ scrollTop: 0 }, "fast");
      this.loadedFileStatus = false;
      $('.nav-tabs a[href="#overviewTab"]').tab('show');
    },
    editRow(id) {
      this.loadedFileStatus = true;
      var fileEditor = this.$refs.fileEditor;
      this.fileLoaded = 'untouched';
      this.loadFileId = id;
      fileEditor.loadFileDetails(id);
      $('.nav-tabs a[href="#detailTab"]').tab('show');
    },
    downloadFiles(fileId, filename) {
      Webservice.downloadFile(fileId, filename).then((resp) => {
      if(resp.headers) {
              var headers = resp.headers;
              var a = document.createElement('a');
              let contenttype = resp.headers["content-type"];
              
              var blob = new Blob([resp.data], {type: contenttype});
              var url = window.URL.createObjectURL(blob);

              a.style = "display: none";  
              a.href = url;
              if(typeof(filename) === 'undefined') {
                filename = 'archive_download_' + fileId;
              }
              a.download = filename;

              document.body.appendChild(a);
              a.click();
              setTimeout(function(){
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);  
            }, 1500);
          }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/AutomaticFileservice/Overview.vue